import React from 'react';
import { Link } from 'react-router-dom';
import Estimator from '../components/Estimator';
import AnimatedCounter from '../components/AnimatedCounter';
import FloatingCTA from '../components/FloatingCTA';

export default function Home(){
  return (
    <main>
      <section className="hero">
        <div className="hero-inner">
          <h1>Liberty Street Food</h1>
          <p className="lead">Smashburger Catering — frisch, schnell und zuverlässig für Firmen, Hochzeiten und Festivals.</p>
          <div className="cta">
            <Link className="btn" to="/kontakt">Angebot anfragen</Link>
            <Link className="btn ghost" to="/leistungen">Unsere Leistungen</Link>
          </div>
        </div>
      </section>

      <section>
        <h2 className="title">Warum Liberty?</h2>
        <p className="subtitle" style={{textAlign:'center',maxWidth:900,margin:'0 auto 28px'}}>Seit 2016 bieten wir Full-Service-Catering mit Fokus auf handgemachte Smashburger, kreative Pommes-Kreationen und zuverlässigen Event-Service.</p>

        <div className="stats">
          <div className="stat"><h3><AnimatedCounter end={720} /></h3><p>Events begleitet</p></div>
          <div className="stat"><h3><AnimatedCounter end={86400} /></h3><p>Burger serviert</p></div>
          <div className="stat"><h3><AnimatedCounter end={48} suffix="%" duration={1200} /></h3><p>Durchschnittsbewertung (0-50)</p></div>
          <div className="stat"><h3>Bundesweit</h3><p>NRW & ganz Deutschland</p></div>
        </div>
      </section>

      <section id="leistungen">
        <h2 className="title">Unsere Spezialitäten</h2>
        <div className="cards">
          <div className="card"><h3>Smashburger</h3><p>Saftig gegrillte Patties, knackiges Brötchen und hausgemachte Saucen.</p></div>
          <div className="card"><h3>Loaded Fries</h3><p>Knusprig, kreativ belegt — von klassischen Cheese Fries bis zu Truffle Fries.</p></div>
          <div className="card"><h3>Getränke & Bar</h3><p>Softdrinks, hausgemachte Limonaden und optionale Cocktailstation.</p></div>
          <div className="card"><h3>Full-Service</h3><p>Foodtruck, Personal, Equipment und Ablaufplanung für Ihr Event.</p></div>
        </div>
      </section>

      <section>
        <h2 className="title">Catering Pakete & Schnellkalkulator</h2>
        <div className="package-estimator-grid">
          <div className="package-list">
            <div className="packages">
              <div className="package">
                <h3>Basic</h3>
                <h1>ab 24,90 €</h1>
                <ul>
                  <li>✓ Smashburger</li>
                  <li>✓ Pommes</li>
                  <li>✓ Mindestpersonal</li>
                </ul>
              </div>

              <div className="package featured">
                <h3>Premium</h3>
                <h1>ab 34,90 €</h1>
                <ul>
                  <li>✓ Burger-Flatrate (zeitlich begrenzt)</li>
                  <li>✓ Loaded Fries & Beilagen</li>
                  <li>✓ Getränke-Paket</li>
                  <li>✓ Live-Cooking-Station</li>
                </ul>
              </div>

              <div className="package">
                <h3>VIP</h3>
                <h1>ab 49,90 €</h1>
                <ul>
                  <li>✓ Premium-Zutaten & Specials</li>
                  <li>✓ Dessert</li>
                  <li>✓ Voller Event-Service</li>
                </ul>
              </div>
            </div>
          </div>

          <Estimator />
        </div>
      </section>

      <section>
        <h2 className="title">Galerie</h2>
        <div className="gallery">
          <img src="https://images.unsplash.com/photo-1550547660-d9450f859349?q=80&w=1200&auto=format&fit=crop" alt="fries" />
          <img src="https://images.unsplash.com/photo-1568901346375-23c9450c58cd?q=80&w=1200&auto=format&fit=crop" alt="burger" />
          <img src="https://images.unsplash.com/photo-1572802419224-296b0aeee0d9?q=80&w=1200&auto=format&fit=crop" alt="truck" />
        </div>
      </section>

      <section>
        <h2 className="title">So funktioniert's</h2>
        <div className="steps">
          <div className="step"><h2>1</h2><p>Anfrage</p></div>
          <div className="step"><h2>2</h2><p>Angebot & Menü</p></div>
          <div className="step"><h2>3</h2><p>Planung & Logistik</p></div>
          <div className="step"><h2>4</h2><p>Durchführung</p></div>
        </div>
      </section>

      <section className="contact-teaser">
        <div style={{maxWidth:900,margin:'0 auto',textAlign:'center',padding:'40px 6%'}}>
          <h3>Bereit für dein Event?</h3>
          <p>Schreib uns Deine Eckdaten — wir machen ein konkretes, transparentes Angebot.</p>
          <Link className="btn" to="/kontakt">Jetzt anfragen</Link>
        </div>
      </section>
      <FloatingCTA />
    </main>
  );
}
